var _ = require('lodash');

function Cons() {
    const obj = {};
    obj.FEATURES = {
        WORKFLOW_ALL: 'WORKFLOW_ALL',
        LISTING_WORKFLOW: 'LISTING_WORKFLOW',
        DOUBLE_ENDED_WORKFLOW: 'DOUBLE_ENDED_WORKFLOW',
        LISTING_GONE_PENDING_WORKFLOW: 'LISTING_GONE_PENDING_WORKFLOW',
        SALES_WORKFLOW: 'SALES_WORKFLOW',
    };
    obj.pagesLabels = Object.freeze({
        salesAgents: 'Agents',
    });
    obj.pages = Object.freeze({
        files: 'files',
        fileDetail: 'filedetail',
        reports: 'reports',
        coordinators: 'coordinators',
        dashBoard: 'dashboard',
        agents: 'agents',
        agentProfile: 'agentprofile',
        makeListing: 'makelisting',
        makeTransaction: 'maketransaction',
        salesAgents: 'sales/agents',
        emailTemplates: 'emailtemplates',
    });
    obj.saleTypes = Object.freeze({
        'Double Ended': 'doubled_ended',
        Lease: 'lease',
        'Lease Listing': 'lease_listing',
        'Listing Gone Pending': 'listing_gone_pending',
        Listing: 'listing',
        Sale: 'sale',
    });
    obj.propertyType = Object.freeze({
        Residential: 'residential',
        Commercial: 'commercial',
        'Vacant Land': 'vacant_land',
        REO: 'reo',
        Probate: 'probate',
        'TC Light': 'tc_light',
    });
    obj.fileStatuses = Object.freeze({
        Closed: 'closed',
        Withdrawn: 'withdrawn',
        Cancelled: 'cancelled',
        Pending: 'pending',
        Expired: 'expired',
        Active: 'active',
        Incomplete: 'incomplete',
    });
    obj.checkStatuses = Object.freeze({
        Requested: 'requested',
        Promotional: 'promotional',
        'First File': 'first_file',
        Received: 'received',
    });
    obj.fileTypes = Object.freeze({
        listing: 0,
        transaction: 1,
    });
    obj.refferalTypes = Object.freeze({
        'Sales Representative': 'sales_rep',
        'Transaction Coordinator': 'tc',
        Inbound: 'inbound',
        'Co-Op': 'coop',
    });
    obj.salesRepresentatives = Object.freeze({
        'Amanda Rep': 'amanda_rep',
        'David Rep': 'david_rep',
    });
    obj.roles = Object.freeze({
        tc: 'tc',
        admin: 'admin',
        superadmin: 'superadmin',
        sales: 'sales',
    });
    obj.holidays = Object.freeze({
        newYearsDay: "New Year's Day",
        martinLutherKingDay: 'Martin Luther King Day',
        washingtonsBirthday: 'Washington’s Birthday',
        memorialDay: 'Memorial Day',
        independenceDay: 'Independence Day',
        laborDay: 'Labor Day',
        veteransDay: 'Veterans Day',
        thanksgivingDay: 'Thanksgiving Day',
        dayAfterThanksgivingDay: 'Day after Thanksgiving Day',
        christmasDay: 'Christmas Day',
    });
    obj.states = Object.freeze({
        AL: 'Alabama',
        AK: 'Alaska',
        AS: 'American Samoa',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'District Of Columbia',
        FM: 'Federated States Of Micronesia',
        FL: 'Florida',
        GA: 'Georgia',
        GU: 'Guam',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MH: 'Marshall Islands',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        MP: 'Northern Mariana Islands',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PW: 'Palau',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VI: 'Virgin Islands',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming',
    });
    obj.prime = {};
    obj.prime.fileContactType = Object.freeze({
        Seller: 69,
        Purchaser: 70,
        TitleCo: 71,
        CoBroker: 72,
        Lender: 73,
        Escrow: 103,
        Attorney: 109,
        HomeWarranty: 132,
        Generic: 187,
        Invoice: 0, // SkyTC
        FileAgent: -1, //SkyTC,
        PortalEmail: -2, //SkyTC i.e PropertyEmail
    });
    obj.prime.fileContactTypeLabel = Object.freeze({
        Seller: 'Seller',
        Purchaser: 'Buyer',
        TitleCo: 'Title',
        CoBroker: 'Co-op Agent',
        Lender: 'Lender',
        Escrow: 'Escrow',
        Attorney: 'Attorney',
        HomeWarranty: 'Home Warranty',
        Invoice: 'Invoice',
        FileAgent: 'Agent',
    });
    
    obj.prime.FileContacTypeKeyLabel = Object.freeze({
        'Agent': -1 , //SkyTC,
        'Attorney':109 ,
        'Buyer':70 ,
        'Co-op Agent':72 ,
        'Escrow':103 ,
        'Generic':187 ,
        'Home Warranty':132 ,
        'Invoice':0 , // SkyTC
        'Lender':73 ,
        'Property Email': -2 , //SkyTC i.e PropertyEmail
        'Seller': 69 ,
        'Title':71 ,
    });
    obj.prime.getFileContactLabelById = function(contactTypeId) {
        return obj.prime.fileContactTypeLabel[_.invert(obj.prime.fileContactType)[contactTypeId]];
    };
    obj.supportedStatesForCalendar = ['ca', 'or', 'nv', 'az', 'nm'];
    obj.transitionTypes = Object.freeze({
        Waiting: 'waiting',
        NotApplicable: 'na',
        Active: 'active',
    });
    obj.transitionTypeLabel = Object.freeze({
        Waiting: 'Waiting',
        NotApplicable: 'N/A',
        Active: 'Active',
    });
    obj.getTransitionTypeLabelById = function(transitionType) {
        return obj.transitionTypeLabel[_.invert(obj.transitionTypes)[transitionType]];
    };

    return Object.freeze(obj);
}

module.exports = Cons();



//////////////////
// WEBPACK FOOTER
// ./isomorphic/cons.js
// module id = ./isomorphic/cons.js
// module chunks = 0